<!-- <div class="page-title-area" *ngFor="let Content of pageTitle;" style="background-image: url({{Content.bgImage}});">
    <div class="container">
        <h1>{{Content.title}}</h1>
    </div>
</div> -->

<div class="profile-authentication-area ptb-30">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 offset-lg-3 col-md-12">
                <div class="login-form">
                    <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12" style="margin-bottom: 25px;">
                            <h2 style="margin: 0;">{{resource.signIn}}</h2>
                        </div>
                        <div style="text-align: right;" class="col-lg-6 col-md-12 col-sm-12">
                            {{resource.create_account}} ? <a href="javascript:void(0)" class="sign-up"
                                style="font-weight: bold;" (click)="onClickSignUp()">{{resource.signUp}}</a>
                        </div>
                    </div>
                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label> {{resource.email}} / {{resource.phone}}</mat-label>
                                <input [placeholder]="resource.email" matInput formControlName="email_phone"
                                    [readonly]="!tokenValid" oninput="this.value = this.value.toLowerCase()" type="text"
                                    maxlength="200">

                                <mat-icon [matTooltip]="resource.verify" matTooltipPosition="above"
                                    *ngIf="this.loginForm.controls.email_phone.status == 'VALID'" matSuffix
                                    class="my-icon" style="cursor: pointer;font-weight: bold"
                                    (click)="checkEmailOrPhone()">
                                    arrow_forward
                                </mat-icon>

                                <!-- Required Field Validation -->
                                <mat-error *ngIf="submittedLogin && f.email_phone.errors?.required">
                                    {{resource.email}} / {{resource.phone}} {{resource.is_required}}
                                </mat-error>

                                <!-- Invalid Email or Phone Validation -->
                                <mat-error *ngIf="submittedLogin && f.email_phone.errors?.invalidInput">
                                    {{resource.invalid}} {{resource.email}} / {{resource.phone}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-group" *ngIf="isShowPassword">
                            <mat-form-field>
                                <mat-label> {{resource.password}}</mat-label>
                                <input matInput [placeholder]="resource.password" formControlName="password"
                                    class="passwordheight" [type]="hide ? 'password' : 'text'" maxlength="20"
                                    [readonly]="!tokenValid">
                                <mat-error *ngIf="submittedLogin && f.password.errors?.required"
                                    class="invalid-feedback">
                                    {{resource.password}} {{resource.is_required}}
                                </mat-error>
                                <mat-error *ngIf="submittedLogin  && f.password.errors?.pattern"
                                    class="invalid-feedback">
                                    {{resource.invalid}} {{resource.password}}
                                </mat-error>
                                <button type="button" class="password" matTooltip="Show Password"
                                    aria-label="Button that displays a tooltip when focused or hovered over"
                                    mat-icon-button matSuffix (click)="togglePasswordVisibility()"
                                    [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
                                    [attr.aria-pressed]="hide">
                                    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                        <div class="row align-items-center" *ngIf="isShowPassword">
                            <div class="col-lg-6 col-md-6 col-sm-6 remember-me-wrap">
                                <p>
                                    <input type="checkbox" id="rememberMe" formControlName="rememberMe">
                                    <label for="rememberMe">{{resource.remember_me}}</label>
                                </p>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 lost-your-password-wrap">
                                <a routerLink="/forgot-password"
                                    class="lost-your-password">{{resource.forgot_password}}?</a>
                            </div>
                        </div>
                        <button *ngIf="showSubmitButton" type="submit">{{resource.signIn}}</button>
                    </form>

                    <!-- <div class="or-divider">OR</div>

                    <div class="mt-2">
                        <button type="button" class="google-login-btn" (click)="loginWithGoogle()">
                            <img src="assets/img/google_icon.png" alt="Google Logo">
                            Continue with Google
                        </button>
                    </div> -->
                    
                    <!-- <div class="mt-2">
                        <button type="button" class="google-login-btn" (click)="loginWithGoogle()">
                            <img src="assets/img/fb_icon.png" alt="Facebook Logo">
                            Continue with Facebook
                        </button>
                    </div>
                    <div class="mt-2">
                        <button type="button" class="google-login-btn" (click)="loginWithGoogle()">
                            <img src="assets/img/microsoft-icon.png" alt="Facebook Logo">
                            Continue with Microsoft
                        </button>
                    </div>
                    <div class="mt-2">
                        <button type="button" class="google-login-btn" (click)="loginWithGoogle()">
                            <img src="assets/img/apple-icon.png" alt="Apple Logo">
                            Continue with Apple
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>